import { styled } from '@linaria/react'

/**
 * Fullscreen layout that allow panels as children.
 */
const FullscreenLayout = styled.div`
    width: 100%;
    height: 100vh;

    display: flex;
    flex-direction: row;
`;

export default FullscreenLayout;
